"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItemSecondaryAction_1 = __importDefault(require("@mui/material/ListItemSecondaryAction"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Bolt_1 = __importDefault(require("@mui/icons-material/Bolt"));
const ExpandLess_1 = __importDefault(require("@mui/icons-material/ExpandLess"));
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const PriorityHigh_1 = __importDefault(require("@mui/icons-material/PriorityHigh"));
const core_1 = require("companion-app-components/utils/core");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const preferencesSelectors = __importStar(require("companion-app-components/flux/preferences/selectors"));
const types_1 = require("companion-app-components/flux/preferences/types");
const errors_1 = require("data/aggErrors/errors");
const selectors_1 = require("data/institutionLogins/selectors");
const selectors_2 = require("data/datasetSharing/selectors");
const auth_1 = require("companion-app-components/flux/auth");
const actions_1 = require("data/aggErrors/actions");
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const Dump_1 = __importDefault(require("components/Dump"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const log = (0, core_1.getLogger)('components/AccountList/AccountRow/index.ts');
const MAX_LEVEL_TO_EXPAND_COLLAPSE = 2;
const AccountRow = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes, theme } = useStyles();
    const institutionLoginsById = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getInstitutionLoginsById)(state));
    const isAllInstitutionLoginsRefreshing = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIsRefreshingAll)(state));
    const institutionLoginsIdsRefreshing = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIdsRefreshing)(state));
    const accountColorsById = (0, react_redux_1.useSelector)((state) => preferencesSelectors.accountColorsById(state));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const isWebFirstDataset = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getIsWebfirstDataset(state));
    const isAllowedToFixAccounts = (0, react_redux_1.useSelector)((state) => (0, selectors_2.getIsFeatureAllowed)(state, selectors_2.AllFeatures.FIX_ACCOUNT));
    const getBalance = (node) => {
        switch (props.balanceType) {
            case 'online':
                return node.sumOnlineAccountBalances;
            case types_1.ShowBalance.BANK_REPORTED:
                return node.sumCPOnlineAccountBalances;
            case 'today':
            case types_1.ShowBalance.INCLUDE_PENDING:
                return node.sumCurrentAccountBalances;
            case 'final':
                return node.sumFinalAccountBalances;
            default:
                return node.sumEndingAccountBalances;
        }
    };
    const handleAggAction = (aggAction) => {
        var _a;
        const institutionId = (aggAction === null || aggAction === void 0 ? void 0 : aggAction.institutionLogin) && (aggAction === null || aggAction === void 0 ? void 0 : aggAction.institutionLogin.institutionId)
            ? (_a = aggAction.institutionLogin) === null || _a === void 0 ? void 0 : _a.institutionId
            : '0';
        if (aggAction.actionWithConfirmation) {
            core_1.tracker.track(core_1.tracker.events.fiLoginFixItFlowStart, {
                type: aggAction.type,
                id: aggAction.id,
                institution_id: institutionId,
                agg_status: aggAction.status,
                agg_status_code: aggAction.statusCode || 'null',
                location: 'account list',
                cancellable: true,
            });
            dispatch(isWebFirstDataset ? aggAction.actionWithConfirmation : (0, actions_1.createErrorDialog)(aggAction));
        }
        else if (aggAction.action) {
            core_1.tracker.track(core_1.tracker.events.fiLoginFixItFlowStart, {
                type: aggAction.type,
                id: aggAction.id,
                institution_id: institutionId,
                agg_status: aggAction.status,
                agg_status_code: aggAction.statusCode || null,
                location: 'account list',
            });
            dispatch(aggAction.action);
        }
    };
    const renderPrimaryText = (node, omitCents, selClass, iconSpace) => {
        var _a;
        let depth = node.depth === 2 && node.isLeaf === true ? 3 : node.depth;
        const balance = getBalance(node);
        const negClass = (getBalance(node) < 0 ? classes.negativeBalDark : classes.positiveBalDark);
        if (node.depth === 1 && node.displayOrder === 0) {
            depth = 0;
        }
        const levelClass = classes[`listItemTextL${depth}`];
        const isClosedAccount = (_a = node === null || node === void 0 ? void 0 : node.account) === null || _a === void 0 ? void 0 : _a.isClosed;
        return (<styles_1.PrimaryTextLine>
        <span style={{ width: `${node.displayLabel.length + 2}ch`, marginRight: isClosedAccount ? 0 : undefined, overflow: 'hidden' }} className={(0, classnames_1.default)(levelClass, 'left', selClass)}>
          <Dump_1.default obj={node}/>
          <QTip_1.default title={node.displayLabel} wrapOnly>
            <Box_1.default sx={{ width: '100%' }} className={(0, classnames_1.default)(levelClass, 'left', selClass)}>
              <Box_1.default component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>
                {isClosedAccount ? <i>{node.displayLabel}</i> : node.displayLabel}
              </Box_1.default>
              {iconSpace}
            </Box_1.default>
          </QTip_1.default>
        </span>
        {isClosedAccount &&
                <i className={classes.closedText}>(Closed)</i>}
        <AmountField_1.default id={`${props.id}-balance`} value={balance} className={(0, classnames_1.default)(levelClass, selClass, negClass)} omitCents={omitCents} currencySymbol={node.currency}/>
      </styles_1.PrimaryTextLine>);
    };
    const renderSecondaryText = (node, institutionLogin) => {
        log.log('Rendering secondary text');
        if (!node.account) {
            // secondary text line only exists when we have an account
            return null;
        }
        let lastSuccessfulRefreshOn = '';
        if (node.account.aggregators && node.account.aggregators.size > 0) {
            const aggregator = node.account.aggregators.get(0);
            if (aggregator.lastRefreshSuccessfulAt) {
                const lastRefreshSuccessAt = luxon_1.DateTime.fromISO(aggregator.lastRefreshSuccessfulAt);
                lastSuccessfulRefreshOn = lastRefreshSuccessAt.toLocaleString();
            }
            log.log('LastSuccessfulRefresh', aggregator.lastRefreshSuccessfulAt, lastSuccessfulRefreshOn);
        }
        return (<styles_1.SecondaryTextLine>
        <div>
          {institutionLogin ? `${institutionLogin.name}` : ''}
        </div>
        <div title="refresh-date">
          {lastSuccessfulRefreshOn}
        </div>
      </styles_1.SecondaryTextLine>);
    };
    const renderAggAction = (institutionLogin, aggStatus, aggStatusCode, depth) => {
        if (institutionLogin != null) {
            if (isAllInstitutionLoginsRefreshing) {
                return null;
            }
            if (institutionLoginsIdsRefreshing.has(institutionLogin.id)) {
                return (<QIconButton_1.default disabled aria-label="Refreshing" classes={{ root: classes.refreshingProgress }} size="small">
            <CircularProgress_1.default size={20} sx={{ color: theme.palette.primary.main }}/>
          </QIconButton_1.default>);
            }
            const aggAction = (0, errors_1.getQcsAggregationAction)(institutionLogin, aggStatus, aggStatusCode, featureFlags, null, isWebFirstDataset, isAllowedToFixAccounts);
            return (<QIconButton_1.default aria-label="aggregation action" classes={{
                    root: classes[`listItemIconButtonL${depth}`],
                }} onClick={(e) => {
                    e.stopPropagation();
                    handleAggAction(aggAction);
                }} size="small">
          {aggAction.type === 'ERROR'
                    ? <PriorityHigh_1.default classes={{ root: classes.errorIcon }}/>
                    : isWebFirstDataset && <Bolt_1.default classes={{ root: classes.infoIcon }}/>}
        </QIconButton_1.default>);
        }
        return null;
    };
    const isLeafNode = props.node.depth === 2 && props.node.isLeaf === true;
    let depth = isLeafNode ? 3 : props.node.depth;
    if (props.node.depth === 1 && props.node.displayOrder === 0) {
        depth = 0;
    }
    let aggStatus = null;
    let aggStatusCode = null;
    if (props.node.account && props.node.account.aggregators) {
        const aggregator = props.node.account.aggregators.get(0);
        aggStatus = aggregator.aggStatus;
        aggStatusCode = aggregator.aggStatusCode;
    }
    const nodeHasFixedExpansion = props.node.depth > MAX_LEVEL_TO_EXPAND_COLLAPSE;
    const nodeIsExpandable = props.node.children && props.node.expandable && !nodeHasFixedExpansion;
    const newNodeId = props.node.id === 'HIDDEN' ? `${props.node.id}_${props.node.type}` : props.node.id;
    const selClass = props.selectedNodeId === newNodeId ? 'selected' : '';
    const institutionLogin = !(props.node.account && props.node.account.institutionLoginId && institutionLoginsById) ? null :
        institutionLoginsById.get(props.node.account.institutionLoginId);
    const drawerTheme = theme.mixins.accountDrawer;
    const expandable = props.node.children && props.node.expandable && !nodeHasFixedExpansion;
    const hasAggAction = (aggStatus != null && aggStatus !== 'OK') || (institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.optionalAction);
    const iconSpace = (<ListItemSecondaryAction_1.default sx={{ right: (drawerTheme.listPaddingRight - drawerTheme.iconSize) / 2 }}>
      {expandable &&
            <QIconButton_1.default aria-label="Expand/Collapse" classes={{
                    root: classes[`listItemIconButtonL${depth}`],
                }} onClick={(e) => {
                    e.stopPropagation();
                    props.onExpandCollapse(props.displayOptions);
                }}>
          {props.displayOptions && props.displayOptions.expand ? <ExpandLess_1.default /> : <ExpandMore_1.default />}
        </QIconButton_1.default>}
      {hasAggAction && renderAggAction(institutionLogin, aggStatus, aggStatusCode, depth)}
    </ListItemSecondaryAction_1.default>);
    const primaryText = renderPrimaryText(props.node, props.omitCents, selClass, iconSpace);
    return (<div role="list">
      <ListItem_1.default button className={(0, classnames_1.default)(selClass, nodeIsExpandable && 'expandable', classes[`listItemL${depth}`])} onClick={(e) => {
            e.stopPropagation();
            props.onClick(props.node);
        }} key={`${props.node.id}`} id={props.id}>
        {props.node.account && props.showColors &&
            <Box_1.default className={classes.accountBar} sx={{ background: accountColorsById[props.node.account.id] }}/>}

        <ListItemText_1.default disableTypography primary={primaryText} secondary={!props.dense ? renderSecondaryText(props.node, institutionLogin) : null} className={(0, classnames_1.default)(selClass, classes.listItemText)} sx={{ width: '100%' }}/>
      </ListItem_1.default>
      {props.node.children && props.node.expandable &&
            <Collapse_1.default classes={{
                    root: classes.collapseContainer,
                }} in={nodeHasFixedExpansion || (props.displayOptions && props.displayOptions.expand)} unmountOnExit>
          {props.node.children
                    .map((child, i) => (<AccountRow {...props} id={`${props.id}-${child.displayLabel}-${i}`} node={child} displayOptions={props.displayOptions && props.displayOptions.children ? props.displayOptions.children.get(child.id) : null} key={child.id} style={{ transitionDelay: `${i * 0.05}s` }}/>))}
        </Collapse_1.default>}
    </div>);
};
exports.default = AccountRow;
